import React, { useEffect, useRef, memo } from 'react';
import LogEntry from './LogEntry';
import styles from './ActivityConsole.module.css';

const ActivityConsole = memo(({ title, activityLog, isScanning }) => {
  const consoleRef = useRef(null);

  // Auto-scroll to bottom when new entries are added
  useEffect(() => {
    if (consoleRef.current) {
      consoleRef.current.scrollTop = consoleRef.current.scrollHeight;
    }
  }, [activityLog]);


  return (
    <div className={styles.activityConsole}>
      <div className={styles.consoleHeader}>
        <div className={styles.titleSection}>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.statusIndicators}>
            <div className={`${styles.statusDot} ${isScanning ? styles.active : ''}`}></div>
            <span className={styles.statusText}>
              {isScanning ? 'MONITORING' : 'STANDBY'}
            </span>
          </div>
        </div>
        <div className={styles.consoleControls}>
          <button className={styles.controlButton} title="Minimize">
            <svg viewBox="0 0 24 24" width="12" height="12">
              <path d="M6 12h12" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
          <button className={styles.controlButton} title="Maximize">
            <svg viewBox="0 0 24 24" width="12" height="12">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
          <button className={styles.controlButton} title="Close">
            <svg viewBox="0 0 24 24" width="12" height="12">
              <path d="M18 6 6 18M6 6l12 12" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
        </div>
      </div>

      <div className={styles.consoleBody} ref={consoleRef}>
        <div className={styles.logContainer}>
          {activityLog.map((entry, index) => (
            <LogEntry
              key={`${entry.time}-${index}`}
              entry={entry}
              index={index}
            />
          ))}
        </div>
      </div>

      <div className={styles.consoleFooter}>
        <div className={styles.footerInfo}>
          <span className={styles.entryCount}>
            {activityLog.length} entries
          </span>
<span className={styles.helpText}>
            Real-time security monitoring
          </span>
        </div>
        <div className={styles.scannerLine}></div>
      </div>
    </div>
  );
});

ActivityConsole.displayName = 'ActivityConsole';

export default ActivityConsole;